/*
 * Lemonade Training Oy, copy rights, all right reserved.
 * SavedIndicator - Brief "Saved" badge shown after successful preference update
 */
import React, { useEffect, useRef } from "react";
import { Badge } from "@lemonadetraining/web-ui";

interface SavedIndicatorProps {
  visible: boolean;
  onHidden?: () => void;
  label?: string;
  durationMs?: number;
}

const SavedIndicator: React.FC<SavedIndicatorProps> = ({
  visible,
  onHidden,
  label = "Preferences saved",
  durationMs = 2000,
}) => {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (visible) {
      timerRef.current = setTimeout(() => {
        onHidden?.();
      }, durationMs);
      return () => {
        if (timerRef.current) clearTimeout(timerRef.current);
      };
    }
  }, [visible, onHidden, durationMs]);

  return (
    <span aria-live="polite" className="inline-flex items-center">
      {visible && (
        <Badge
          variant="outline"
          className="text-xs text-foreground motion-safe:animate-in motion-safe:fade-in motion-reduce:animate-none"
        >
          {label}
        </Badge>
      )}
    </span>
  );
};

export default SavedIndicator;
